/* eslint-disable max-len */
import api from '../../../services/api';

const API_URL = '/api/v1/admin/bidSetup';

/**
 * @returns {Promise<ApiAdmin.GetAllSetupResponse>}
 */
export const getAllSetup = () => api.get(API_URL);

/**
 * @param {string} setupId
 * @returns {Promise<ApiAdmin.GetSetupResponse>}
 */
export const getSetup = (setupId) => api.get(`${API_URL}/${setupId}`);

/**
 * @param {ApiAdmin.ISetupDetailsPresentationModel} setupInformation
 * @returns {Promise<ApiAdmin.CreateSetupResponse>}
 */
export const createSetup = (setupInformation) => api.post(`${API_URL}`, setupInformation);

/**
 * @param {string} setupId
 * @param {ApiAdmin.ISetupDetailsPresentationModel} setupInformation
 * @returns {Promise<ApiAdmin.EditSetupResponse>}
 */
export const updateSetup = (setupId, setupInformation) => api.put(`${API_URL}/${setupId}`, setupInformation);

/**
 * @param {string} setupId
 * @returns {Promise<import('axios').AxiosResponse<any>>}
 */
export const deleteSetup = (setupId) => api.delete(`${API_URL}/${setupId}`);
